import React, { memo } from "react";
import queryString from "query-string";

import { LabMachineAnalysis, FrameContainer } from "..";
import { LabMachineAnalysisProps } from "../../utils/types/components";

const MemoizedLabMachineAnalysis = memo(LabMachineAnalysis);

interface params {
  faena?: string;
  unit?: string;
  subUnit?: string;
  disableMachineFilter?: "true";
  style?: "dashboard" | "custom" | "none";
  title?: string;
  hide?: LabMachineAnalysisProps["hide"];
}

export const SampleAnalysisFrame = (): React.ReactElement => {
  const {
    unit,
    subUnit,
    faena,
    disableMachineFilter,
    title,
    style = "dashboard",
    hide,
  } = queryString.parse(window.location.search) as params;

  return (
    <FrameContainer variant={style} title={title}>
      <MemoizedLabMachineAnalysis
        showLoading={true}
        faenas={[]}
        filters={{
          unit: Array.isArray(unit) ? unit[0] : unit,
          subUnit: Array.isArray(subUnit) ? subUnit[0] : subUnit,
          faena,
        }}
        hide={hide}
        disableMachineFilters={disableMachineFilter === "true" ? true : false}
      />
    </FrameContainer>
  );
};
